// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"fcd006fd","885":"2eb85c97"}[chunkId] + ".chunk.js";
};